<template>
    <div class="ManualOrderConfigurationFee">
        <div class="summary_bag">
			<div class="summary_complete_bag">
				<!-- 时间 -->
				<el-form
					:inline="true"
					label-width="120px"
					ref="selectForm"
					:model="selectForm"
				>
					<el-form-item label="资源配置类型" prop="isTranslation">
						<el-select v-model="selectForm.isTranslation" clearable>
							<!-- <el-option label="全部" :value="1"></el-option> -->
							<el-option label="添加买家账号" :value="2"></el-option>
							<el-option label="添加信用卡账号" :value="3"></el-option>
							<el-option label="添加买家地址" :value="4"></el-option>
							<el-option label="添加下单IP地址" :value="5"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="开始时间" prop="startTime">
						<el-date-picker
							v-model="selectForm.startTime"
							align="right"
							type="datetime"
							placeholder="选择开始时间"
							value-format="yyyy-MM-dd HH:mm:ss"
							style="width:200px;"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="结束时间" prop="endTime">
						<el-date-picker
							v-model="selectForm.endTime"
							align="right"
							type="datetime"
							placeholder="选择结束时间"
							value-format="yyyy-MM-dd HH:mm:ss"
							style="width:200px;"
						></el-date-picker>
					</el-form-item>
					<el-form-item label=" " prop="input">
						<el-input
							class="custom-input"
							v-model="selectForm.input"
							placeholder="全字段搜索"
							style="width:530px;"
							clearable
						></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary"
							@click="Search"
							>搜索</el-button
						>
						<el-button
							type="primary"
							 @click="searchReset"
							>重置</el-button
						>
					</el-form-item>
					<!-- </div> -->
				</el-form>
			</div>
			<div class="summary_content">
				<div class="summary_list">
					<!-- 头部 -->
					<el-table
						:data="summarylist"
						style="width: 100%"
						v-loading="load_data"
						element-loading-text="拼命加载中"
						border
						:header-cell-style="iscenter"
						stripe
					>
						<el-table-column
							label="导入批次"
							prop="batchNumber"
							align="center"
						></el-table-column>
						<el-table-column prop="importCount" label="导入数量" align="center">
						</el-table-column>
						<el-table-column
							label="资源配置类型"
							align="center"
						>
							<template slot-scope="scope">
								<p v-if="scope.row.type === 1">添加买家账号</p>
								<p v-else-if="scope.row.type === 2">添加信用卡账号</p>
								<p v-else-if="scope.row.type === 3">添加买家地址</p>
								<p v-else-if="scope.row.type === 4">添加下单IP地址</p>
							</template>
						</el-table-column>
						<el-table-column
							prop="totalCost"
							label="花费总计(元)"
							align="center"
						></el-table-column>
						<el-table-column
							label="付款凭证"
							align="center"
						>
							<template slot-scope="scope">
								<el-image
									style="width: 50px; height: 50px"
									:src="scope.row.uploadCertificates[0]"
									:preview-src-list="scope.row.uploadCertificates"></el-image>
							</template>
						</el-table-column>
						<el-table-column
							prop="createTime"
							label="添加时间"
							align="center"
						>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="summary_pagenum_block">
				<div class="block">
					<el-pagination
						@current-change="handleCurrentChange"
						:current-page="page"
					    :page-size="size"
						@size-change="handleSizeChange"
						:page-sizes="[10, 20, 50, 100]"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</div>
			</div>
		</div>  
    </div>
</template>
<script>
import { ajaxPost, Baseurl } from '../../../../api/api/api'
export default {
    name: 'ManualOrderConfigurationFee',
    data() {
        return {
			total: 0,
			page: 1,
			size: 20,
			companyId: '',
			iscenter: {
				textAlign: 'center',
				background: '#f8f8f8',
				color: '#232323',
			},
			load_data: false,
			UserInfo: {},
            summarylist: [],
			selectForm: {
				startTime: '',
				endTime: '',
				input: '',
				isTranslation: '',
			},
        }
    },
	created() {
        this.UserInfo = JSON.parse(localStorage.getItem('role'))
		this.companyId = this.UserInfo.company_id
		this.selectRecordList()
	},
	methods: {
		Search() {
			this.selectRecordList()
		},
		selectRecordList() {
			this.load_data = true
			const API = Baseurl + 'expenseRecordController/selectExpenseRecordList'
			const paramsData = {
				companyId: this.companyId,
				page: this.page,
				size: this.size,
				type: this.selectForm.isTranslation,
				beginDate: this.selectForm.startTime,
				endDate: this.selectForm.endTime
			}
			ajaxPost(API,paramsData)
				.then((res) => {
					this.load_data = false
					if( res.data.code === 200 ) {
						this.summarylist = res.data.data.list
						this.total = res.data.data.total
					}else {
						this.$message.error(res.data.data)
					}
				})
		},
		searchReset() {
			this.selectForm.isTranslation = ''
			this.selectForm.startTime = ''
			this.selectForm.endTime = ''
			this.selectForm.input = ''

			this.selectRecordList()
		},
        handleSizeChange(val) {
			this.size = val
			this.selectRecordList()
		},
		handleCurrentChange(val) {
			this.page = val
			this.selectRecordList()
		}
	},
}
</script>
<style lang="scss" scoped>
.ManualOrderConfigurationFee{
	width: 98%;
	// background: #F7F7F7;
	padding-bottom: 72px;
	.summary_bag {
		width: 98%;
		margin: auto;
		.summary_complete_bag {
			overflow: hidden;
            .span-box{
                display: flex;
                align-items: center;
                justify-content: flex-end;
                .el-icon-question{
                    font-size: 14px;
                }
            }
		}
		.summary_pagenum {
			width: 99.6%;
			margin-bottom: 10px;
			overflow: hidden;
			background: #f5f5f5;
            display: flex;
            justify-content: flex-end;
            padding: 5px;
		}
		.summary_content {
			width: 100%;
			border: 1px solid #eee;
			overflow: hidden;
            .summary_list {

            }
		}
		.summary_pagenum_block {
			width: 1790px;
			padding: 20px;
			position: fixed;
			right: 0;
			bottom: 0;
			background: #fff;
			z-index: 999;
			.el-pagination {
				display: flex;
				justify-content: center;
			}
		}
	}
}
</style>